export default function measure(name, options) {
    try {
        performance.measure(name, options);
    } catch (err) {
    // Older versions of Firefox may throw a DOMException
    }
}

//# sourceMappingURL=performance.js.map